import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import AppCard from 'main/core/AppCard';
import PropTypes from 'prop-types';
import {Fonts} from 'shared/constants/AppEnums';

const CurrencyStats = (props) => {
  const {icon, data, heading} = props;

  return (
    <AppCard
      sxStyle={{
        borderRadius: (theme) =>
          theme.components.MuiCard.styleOverrides.root.borderRadius / 4,
      }}
      className='card-hover'
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Avatar
          sx={{
            p: 1.5, // Reduced padding so the icon can breathe
            height: {xs: 46, md: 50, xl: 60},
            width: {xs: 46, md: 50, xl: 60},
            backgroundColor: data.color,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box
            component='img'
            src={icon}
            alt=''
            sx={{
              width: '75%',
              height: 'auto',
              objectFit: 'contain', // Ensures the symbol doesn't distort
            }}
          />
        </Avatar>

        <Box
          sx={{
            position: 'relative',
            ml: 4,
          }}
        >
          <Box
            component='p'
            sx={{
              fontSize: 14,
              color: 'text.secondary',
              mb: 2,
            }}
          >
            {heading}
          </Box>
          <Box
            component='h3'
            sx={{
              display: 'inline-block',
              fontWeight: Fonts.MEDIUM,
              fontSize: 17,
              mr: 3,
            }}
          >
            {data.value}
          </Box>
        </Box>
      </Box>
    </AppCard>
  );
};

export default CurrencyStats;

CurrencyStats.propTypes = {
  icon: PropTypes.string,
  data: PropTypes.object,
  heading: PropTypes.any.isRequired,
};
